import React from "react"
import Grid from "@mui/material/Grid"
import { StaticImage } from "gatsby-plugin-image"
import Text from "../components/typography/text"
import useMediaQuery from "@mui/material/useMediaQuery"
import { useTheme } from "@mui/material"
import { Container } from "@material-ui/core"

const OurMission = () => {
  const theme = useTheme()
  const smDown = useMediaQuery(theme.breakpoints.down("sm"))

  return (
    <div style={{ backgroundColor: "white" }}>
      <Container
        maxWidth="lg"
        style={{
          display: "flex",
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            style={{ paddingTop: "140px" }}
          >
            <Text
              variant={"h5"}
              style={{
                color: "#3978E4",
              }}
            >
           
            </Text>
            <br></br>
            <Text variant={"h4"} style={{ fontWeight: "bold" }}>
              DOCTORS FOR SYRIA (DFS)<br></br>IS A NON-PROFIT HEALTH CARE
              INITIATIVE
            </Text>

            <Text variant={"body2"} style={{ paddingTop: "25px" }}>
              We are devoted to complementing and strengthening the health care
              provided to the Syrian citizens. DFS consist of a group of
              experienced and licensed physicians representing different schools
              of medicine tending from North America to Europe and the Middle
              East. They will serve to provide medical second options to Syrian
              patients and to Syrian doctors who desire consultation from a
              colleague. Our physicians are compassionate and committed to
              providing their service with individual and personal attention.
            </Text>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lx={6}
            lg={6}
            style={{ paddingLeft: smDown ? "0px" : "100px" }}
          >
            <StaticImage
              src="../images/Untitled-4.png"
              quality={95}
              width={450}
              formats={["auto", "webp", "avif"]}
              alt="mission"
              style={{
                top: "3ch",
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            style={{ paddingTop: "120px" }}
          >
            <Text variant={"h4"} style={{ fontWeight: "bold" }}>
              A NON-PROFIT ORGANIZATIOM THAT TAKES YOUR 
              WELL-BEING AS THEIR MAIN RRIORITY.
            </Text>

            <Text
              variant={"body2"}
              style={{ color: "black", paddingTop: "22px" }}
            >
              <span
                style={{
                  height: "5px",
                  width: "5px",
                  backgroundColor: "#3978E4",
                  borderRadius: "30px",
                  display: "inline-block",
                  marginBottom: "3px",
                  marginRight: "4px",
                }}
              ></span>
              Our Mission is to communicate with practicing physicians who seek
              a second option from a colleague regarding a medical case under their care and Syrian residing
              within the country but will be extended to serve Syrians anywhere
              as a capacity permit.
            </Text>

            <Text
              variant={"body2"}
              style={{ color: "black", paddingTop: "22px" }}
            >
              <span
                style={{
                  height: "5px",
                  width: "5px",
                  backgroundColor: "#3978E4",
                  borderRadius: "30px",
                  display: "inline-block",
                  marginBottom: "3px",
                  marginRight: "4px",
                }}
              ></span>
              Our service is delivered via web communication channels (Email,
              voice over IP service, etc.) or any other channel agreed upon between the parties involved.
            </Text>
    

            <Text
              variant={"body2"}
              style={{ color: "black", paddingTop: "22px" }}
            >
              <span
                style={{
                  height: "5px",
                  width: "5px",
                  backgroundColor: "#3978E4",
                  borderRadius: "30px",
                  display: "inline-block",
                  marginBottom: "3px",
                  marginRight: "4px",
                }}
              ></span>
              The cases will be reviewed by our physicians (including but not
              restricted to history and physical exam, laboratory and imaging studies), and through proper communication
              feedback will be provided.
            </Text>
        
            <Text
              variant={"body2"}
              style={{ color: "black", paddingTop: "22px" }}
            >
              <span
                style={{
                  height: "5px",
                  width: "5px",
                  backgroundColor: "#3978E4",
                  borderRadius: "30px",
                  display: "inline-block",
                  marginBottom: "3px",
                  marginRight: "4px",
                }}
              ></span>
              Our model tries to overcome the distance obstacle and the lack of
              direct Physician contact and exam by restoring to modern communication technologies, intensifying
              information reporting, and relying on.
            </Text>
            <Text variant={"body2"}>
             
            </Text>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}    style={{ paddingLeft: smDown ? "0px" : "100px", marginTop:"20px" }}>
            <StaticImage
              src="../images/Untitled-2.png"
              quality={95}
              width={450}
              formats={["auto", "webp", "avif"]}
              alt="mission"
              style={{
              
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}
export default OurMission
